import { RouteComponentProps } from 'react-router-dom'
import * as React from 'react'
import { Route } from 'react-router'
import { ROUTES } from '../lib/constants'
import WebsiteNamePage from './WebsiteNamePage'
import WebsiteClaimPage from './WebsiteClaimPage'

const WebsiteClaimIndexPage: React.FC<RouteComponentProps> = () => {
  return (
    <>
      <Route path={ROUTES.websiteClaim.home.path} component={WebsiteNamePage} exact />
      <Route path={ROUTES.websiteClaim.claim.path} component={WebsiteClaimPage} />
    </>
  )
}

export default WebsiteClaimIndexPage
